import GlobalNotificationSettingsAPI from '../../api/globalNotificationSettings';

const state = {
  record: {
    enabled: false,
    selected_email_flags: [],
    selected_push_flags: [],
  },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getEnabled($state) {
    return $state.record.enabled;
  },
  getSelectedEmailFlags($state) {
    return $state.record.selected_email_flags || [];
  },
  getSelectedPushFlags($state) {
    return $state.record.selected_push_flags || [];
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await GlobalNotificationSettingsAPI.get();
      commit('SET_RECORD', response.data);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  update: async (
    { commit },
    { enabled, selectedEmailFlags, selectedPushFlags }
  ) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await GlobalNotificationSettingsAPI.update({
        global_notification_setting: {
          enabled,
          selected_email_flags: selectedEmailFlags,
          selected_push_flags: selectedPushFlags,
        },
      });
      commit('SET_RECORD', response.data);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  SET_RECORD($state, data) {
    $state.record = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
